// extracted by mini-css-extract-plugin
export var hidden = "_tr-0";